import { t } from "i18next";
import * as yup from "yup";
import { HtmlContentResponse } from "../../../js/common/PopupEditFormService";
import ajaxClient from "../../../js/common/AjaxClient";
import { Validation } from "../localization/localeValidation";
import eshopFormValidationService from "../general/EshopFormValidationService";
import elementService from "@/common/ElementService";

const subscribeNewsletterSchema = yup.object({
    email: yup.string().trim()
        .lowercase()
        .matches(Validation.EmailRegEx, t("header:validEmail"))
        .required("E‑mail je povinný"),
}).required();
type SubscribeNewsletterFormSchema = yup.InferType<typeof subscribeNewsletterSchema>;

export default new class NewsletterSubscribeFormService {
    public init(): void {
        const newsletterForm = elementService.querySelector<HTMLFormElement>("#js-newsletter-subscribe-form");

        eshopFormValidationService.init<SubscribeNewsletterFormSchema>(newsletterForm, subscribeNewsletterSchema, {
            onValidSubmit: (): void => void this.submitRegisterNewsletterForm(newsletterForm),
        });
    }

    private async submitRegisterNewsletterForm(newsletterForm: HTMLFormElement): Promise<void> {
        const response = await ajaxClient.post<HtmlContentResponse>(
            "/Customer/jsRegisterNewsletter",
            {
                email: elementService.elementQuerySelector<HTMLInputElement>(newsletterForm, "#newsletter_email").value.trim(),
                source: "ASIDE",
            },
        );

        newsletterForm.innerHTML = response.html;
    }
}();
